import { useLocation } from '@remix-run/react';
import type { TNavbarMenuBurgerElement } from '@shared/dream-components';
import { NavbarMenuBurger as NavbarMenuBurgerElement, useNavbarMenuBurgerContext } from '@shared/dream-components';
import { type ReactNode, Suspense, useEffect } from 'react';

interface Props {
  node: TNavbarMenuBurgerElement;
  children: ReactNode | ReactNode[];
  screen: 'desktop' | 'mobile';
}

const NavbarMenuBurger = ({ node, children, screen }: Props) => {
  const { isOpen, setIsOpen } = useNavbarMenuBurgerContext();
  const location = useLocation();

  // Close menu on route change
  useEffect(() => {
    if (isOpen) {
      setIsOpen(false);
    }
  }, [location]);

  return (
    <Suspense fallback={null}>
      <NavbarMenuBurgerElement element={node} screen={screen} controlbyselected="false">
        {children}
      </NavbarMenuBurgerElement>
    </Suspense>
  );
};

export default NavbarMenuBurger;
